import type { TFunction } from 'i18next';
import { backendCode } from '@/api/errors';

const COMMISSION_PLAN_ERRORS: Readonly<Record<string, string>> = {
  COMMISSION_PLAN_NOT_FOUND: 'commissionPlans.error.notFound',
  COMMISSION_PLAN_NOT_ACTIVE: 'commissionPlans.error.notActive',
  COMMISSION_PLAN_NONCOMPLIANT: 'commissionPlans.error.noncompliant',
  COMMISSION_PLAN_IMMUTABLE: 'commissionPlans.error.immutable',
  COMMISSION_PLAN_NAME_TAKEN: 'commissionPlans.error.nameTaken',
  COMMISSION_PLAN_VERSION_CONFLICT: 'commissionPlans.error.versionConflict',
  NO_RATE_CARD: 'commissionPlans.error.noRateCard',
};

/** `409 NO_RATE_CARD` (TMMAPI-0154 §I): no adopted price card, so a plan can't be created or activated. */
export function isNoRateCard(err: unknown): boolean {
  return backendCode(err) === 'NO_RATE_CARD';
}

/**
 * A translated message for tmm-api's commission-plan codes (TMMAPI-0104; the assignment codes are
 * TMMRSL-0050's too); `null` for any other error. Callers fall back to `describeApiError`; the
 * server's `message` is never shown for these.
 */
export function commissionPlanErrorMessage(err: unknown, t: TFunction): string | null {
  const code = backendCode(err);
  // `hasOwn`, so a code such as `constructor` never resolves to an `Object.prototype` member.
  if (code === undefined || !Object.hasOwn(COMMISSION_PLAN_ERRORS, code)) return null;
  return t(COMMISSION_PLAN_ERRORS[code] as string);
}
